import { Dispatch } from 'vuex';
import SpecialEvent from '@core/models/specials/SpecialEvent';
import { IState } from '@app/store';
import { ExpandedEventInUrl } from '@app/enums';
import { removeEventQueryParams } from '@app/utils';
import { getTimeFilterFromSlug, getTimeFilterFunctionForTimeFilter } from '@shared/timeFilter/helpers';
import { TimeFilter } from '@shared/timeFilter/enums';

export interface ISpecialsState {}

export default {
    namespaced: true,
    state: {} as ISpecialsState,
    getters: {
        expandedEventId: (state: ISpecialsState, getters: any, rootState: IState, rootGetters: any) => {
            let eventId = rootGetters['navigation/route'].query[ExpandedEventInUrl.event];
            eventId = eventId ? parseInt(eventId, 10) : null;

            if (!rootGetters['data/specialOffer/specialEventsMap'][eventId]) {
                return null;
            }
            return eventId;
        },
        timeFilter(state: ISpecialsState, getters: any, rootState: IState, rootGetters: any) {
            const timeFilterSlug = rootState.route.params.timeFilter;
            return timeFilterSlug ? getTimeFilterFromSlug(timeFilterSlug) : TimeFilter.all;
        },
        eventsFilteredByDate(state: ISpecialsState, getters: any, rootState: IState, rootGetters: any) {
            const events = rootGetters['data/specialOffer/specialEvents'];
            const filters: Function[] = [
                (event: SpecialEvent) => event.isCurrentlyOffered(),
            ];

            filters.push(getTimeFilterFunctionForTimeFilter(getters.timeFilter));

            return events.filter((event: SpecialEvent) => filters.every((func: Function) => func(event)));
        },
    },
    actions: {
        toggleExpandedEvent: (
            { getters, rootGetters, dispatch }:
                { getters: any, rootGetters: any, dispatch: Dispatch },
            eventId: number
        ) => {
            let query = rootGetters['navigation/route'].query;

            if (getters.expandedEventId === eventId) {
                query = removeEventQueryParams(query);
            } else {
                query = {
                    ...query,
                    [ExpandedEventInUrl.event]: eventId.toString(),
                };
            }

            dispatch(
                'navigation/push',
                {
                    query,
                    path: rootGetters['navigation/route'].path,
                },
                { root: true }
            );
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/specialOffer/specialPageIndex.ts